import { Injectable } from '@angular/core';

import { ContactEditionComponent } from '../private/CONTACT/contact-edition/contact-edition.component';
import { DialogService } from 'primeng/dynamicdialog';
import { GuardConfirmModalComponent } from 'src/app/components/modals/guard-confirm-modal/guard-confirm-modal.component';

@Injectable({
  providedIn: 'root',
})
export class ConfirmDeactivateGuard {
  constructor(private dialogService: DialogService) {}

  canDeactivate(component: ContactEditionComponent): Promise<boolean> {
    return new Promise((resolve) => {
      if ((component.contactForm.dirty === false || component.isFormSubmit === true) && component.editEnabledGuard === false) {
        resolve(true);
      } else {
        const ref = this.dialogService.open(GuardConfirmModalComponent, {
          header: 'Confirmation',
          styleClass: 'super-compos-modal-content confirm-inforius',
          dismissableMask: false,
          width: '30em',
          data: {
            message: 'Etes-vous sûr de vouloir quitter ?',
          },
        });
        ref.onClose.subscribe({
          next: (value) => {
            if (value) {
              if (value === true) {
                resolve(true);
              } else {
                resolve(false);
              }
            }
          },
        });
      }
    });
  }
}
